import React, { Fragment, useEffect, useState } from 'react'
import { useHistory, useParams, withRouter } from 'react-router-dom'
import { routes } from '../../../../constantes/routes'
import '../../../../assests/styles/contatcs/ContactDetail.scss'
import { useDispatch } from 'react-redux'
import { hospitalsContactsActions } from '../../../../actions/hospitalsContactsActions'
import EditBtn from '../../../buttons/EditBtn'
import DeleteBtn from '../../../buttons/DeleteBtn'
import PlusBtn from '../../../buttons/PlusBtn'
import NewContactNoteModal from '../NewContactNoteModal'
import { onSubmitText } from '../../../../constantes/onSubmitText'
import { hospitalsContactsTypes } from '../../../../constantes/actionTypes'
import { swalMssgs } from '../../../../constantes/swalMssgs'
import { swalTitle } from '../../../../constantes/swalTitle'
import {
  swalAlertError,
  swalAlertIsConfirm,
  swalSuccessGeneral,
} from '../../../../utils/swalAlert'

const ContactNoteDetail = ({ canEdit = false, onEditNote }) => {
  const { id } = useParams()
  const history = useHistory()

  const dispatch = useDispatch()
  const getContactNotes = () =>
    dispatch(hospitalsContactsActions.getContactNotes(id))
  const createContactNote = (id_Contacto, contactNote) =>
    dispatch(
      hospitalsContactsActions.createContactNote(id_Contacto, contactNote),
    )
  const deleteContactNote = (idContact, idNote) =>
    dispatch(hospitalsContactsActions.deleteContactNote(idContact, idNote))

  const [items, setItems] = useState([])
  const [newContactNote, setNewContactNote] = useState({})
  const [modalIsOpen, setIsOpen] = useState({
    createModal: false,
    editModal: false,
  })

  useEffect(() => {
    retrieveContactNotes()
  }, [])

  const retrieveContactNotes = async () => {
    const response = await getContactNotes()
    setItems(response.payload || [])
  }

  const openNewModal = () => {
    setNewContactNote({ id_Contacto: id })
    setIsOpen({
      createModal: true,
      editModal: false,
    })
  }

  const closeModal = () => {
    setIsOpen({
      createModal: false,
      editModal: false,
    })
  }

  const handleSubmitNote = async (event) => {
    event.preventDefault()
    try {
      const response = await createContactNote(
        newContactNote.id_Contacto,
        newContactNote,
      )
      if (
        hospitalsContactsTypes.CREATE_HOSPITALS_CONTACT_NOTE_SUCCESS ===
        response.type
      ) {
        swalSuccessGeneral(swalTitle.CreadoCorrectamente, swalMssgs.NEW_SUCCES)
        closeModal()
        // Refrescar las notas
        retrieveContactNotes()
      }
    } catch (error) {
      swalAlertError(error.response.data || error.response.statusText)
    }
  }

  const handleChangeNewContactNote = (e) => {
    const value = e.target.value
    const name = e.target.name
    setNewContactNote({ ...newContactNote, [name]: value })
  }

  const toEditContact = (noteId) => {
    if (canEdit && onEditNote) {
      onEditNote(noteId)
    }
  }

  const handleDeleteNote = async (note) => {
    try {
      const alert = await swalAlertIsConfirm(
        '¿Seguro que quieres eliminar esta nota?',
      )
      if (alert.isConfirmed) {
        // Mostrar alert de que no está implementado
        window.alert(
          'Funcionalidad de eliminar nota no implementada en el backend',
        )

        // Código comentado para cuando se implemente el backend:
        /*
        const response = await deleteContactNote(id, note.id)
        if (response.type === hospitalsContactsTypes.DELETE_HOSPITALS_CONTACT_NOTE_SUCCESS) {
          swalSuccessGeneral(swalTitle.Eliminado, 'Nota eliminada correctamente')
          // Refrescar las notas
          retrieveContactNotes()
        }
        */
      }
    } catch (error) {
      swalAlertError(
        error.response.data ||
          error.response.statusText ||
          'Error al eliminar la nota',
      )
    }
  }

  return (
    <Fragment>
      {items && items.length > 0 && (
        <div className='products contact-notes-section'>
          <div className='products__title__container'>
            <h2>Notas del contacto</h2>
            {canEdit && (
              <div>
                <button
                  onClick={openNewModal}
                  className='btn-filled add-note-btn'
                >
                  <PlusBtn />
                  Añadir Nota
                </button>
              </div>
            )}
          </div>
          <table>
            <thead>
              <tr>
                <th>
                  <h4 className='products__sub'>Fecha</h4>
                </th>
                <th>
                  <h4 className='products__sub'>Nota</h4>
                </th>
                {canEdit && (
                  <>
                    <th>
                      <h4 className='products__sub'>Editar</h4>
                    </th>
                    <th>
                      <h4 className='products__sub'>Eliminar</h4>
                    </th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {items.map((note, index) => (
                <tr key={note.id_Nota || note.id || `note-${index}`}>
                  <td>
                    <p className='products__text'>
                      {note.fechaCreacion.split('T')[0]}
                    </p>
                  </td>
                  <td>
                    <p className='products__text'>{note.nota}</p>
                  </td>
                  {canEdit && (
                    <>
                      <td className='products__edit'>
                        <button onClick={() => toEditContact(note)}>
                          <EditBtn />
                        </button>
                      </td>
                      <td className='products__edit'>
                        <button onClick={() => handleDeleteNote(note)}>
                          <DeleteBtn />
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Mostrar botón incluso si no hay notas, pero solo si canEdit es true */}
      {canEdit && (!items || items.length === 0) && (
        <div className='products contact-notes-section'>
          <div className='products__title__container'>
            <h2>Notas del contacto</h2>
              <button
                onClick={openNewModal}
                className='action-button'
              >
                <PlusBtn />
                <span>Añadir Nota</span>
              </button>
          </div>
          <p className='no-notes-message'>
            No hay notas para este contacto. ¡Añade la primera!
          </p>
        </div>
      )}

      {/* Modal para crear nueva nota */}
      <NewContactNoteModal
        newContactNote={newContactNote}
        modalIsOpen={modalIsOpen.createModal}
        closeModal={closeModal}
        handleSubmit={handleSubmitNote}
        handleChange={handleChangeNewContactNote}
        textBtn={onSubmitText.Crear}
      />
    </Fragment>
  )
}

export default withRouter(ContactNoteDetail)
